import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {DailyReportsService} from '../../services/daily-reports.service';
import {DailyReportsComponent} from './daily-reports.component';
import {DailyReportsModalComponent} from './daily-reports-modal/daily-reports-modal.component';
import {DailyReportsListComponent} from './daily-reports-list/daily-reports-list.component';
import {DailyReportsFilterComponent} from '../../components/daily-reports-filter/daily-reports-filter.component';
import {DailyReportsAddEntryModalComponent} from './daily-reports-add-entry-modal/daily-reports-add-entry-modal.component';
import {DailyReportsViewReportModalComponent} from './daily-reports-view-report-modal/daily-reports-view-report-modal.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {DailyReportsDetailedViewComponent} from './daily-reports-detailed-view/daily-reports-detailed-view.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        UtilsModule
    ],
    declarations: [
        DailyReportsComponent,
        DailyReportsModalComponent,
        DailyReportsListComponent,
        DailyReportsFilterComponent,
        DailyReportsAddEntryModalComponent,
        DailyReportsViewReportModalComponent,
        DailyReportsDetailedViewComponent
    ],
    exports: [
        DailyReportsModalComponent
    ],
    providers: [
        DailyReportsService
    ]
})
export class DailyReportsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports.module.ts